// src/pages/vendor/VendorProfile.jsx
import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Alert,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import Swal from "sweetalert2";
import useApi from "../../hooks/useApi";
import { useAuth } from "../../context/AuthContext";
import ChangePasswordCard from "../ChangePasswordCard";
import "./ProfileV.css";

const VendorProfile = () => {
  const { user, updateUser } = useAuth();
  const { bearerAuth } = useApi();

  const vendor = user?.data ? user.data : user;
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_URL;

  const [showEdit, setShowEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});

  useEffect(() => {
    if (vendor) {
      setForm({
        name: vendor.vendor_name || vendor.name || "",
        business_name: vendor.business_name || "",
        business_type: vendor.business_type || "",
        phone: vendor.phone || "",
        email: vendor.email || "",
        address: vendor.address || "",
        city: vendor.city || "",
        state: vendor.state || "",
        zipcode: vendor.zipcode || "",
        gst_number: vendor.gst_number || "",
        bank_details: vendor.bank_details || "",
        license_number: vendor.license_number || "",
        experience_years: vendor.experience_years || "",
        google_map_link: vendor.google_map_link || "",
      });
    }
  }, [vendor]);

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        formData.append(key, form[key]);
      });

      await bearerAuth("/vendor/edit", "POST", formData, true);

      Swal.fire("Success", "Profile updated successfully", "success");

      updateUser({
        data: {
          ...vendor,
          ...form,
        },
      });

      setShowEdit(false);
    } catch (err) {
      Swal.fire("Error", err.message || "Update failed", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!vendor) {
    return <Alert variant="danger">Vendor data not found</Alert>;
  }

  return (
    <>
      <div className="profile-container1">
        <div className="profile-header1">
          <h2>Vendor Profile</h2>
          <Button onClick={() => setShowEdit(true)}>Edit Profile</Button>
        </div>

        <Card className="profile-card1">
          <Card.Body>
            <Row className="align-items-center">
              {/* LEFT */}
              <Col md={3} className="text-center">
                <img
                  src={
                    vendor.photo
                      ? IMAGE_BASE + vendor.photo
                      : "/no-img.png"
                  }
                  alt="Vendor"
                  className="vendor-profile-img1"
                />
                <h5 className="mt-3">
                  {vendor.name || vendor.vendor_name}
                </h5>
                <small className="text-muted">
                  {vendor.business_type}
                </small>
              </Col>

              {/* RIGHT */}
              <Col md={9}>
                <Row className="profile-info1">
                  <Col md={6}><span>Business</span><p>{vendor.business_name}</p></Col>
                  <Col md={6}><span>Phone</span><p>{vendor.phone}</p></Col>
                  <Col md={6}><span>Email</span><p>{vendor.email}</p></Col>
                  <Col md={6}><span>City</span><p>{vendor.city}</p></Col>
                  <Col md={6}><span>State</span><p>{vendor.state}</p></Col>
                  <Col md={6}><span>Zip Code</span><p>{vendor.zipcode}</p></Col>
                  <Col md={6}><span>GST Number</span><p>{vendor.gst_number}</p></Col>
                  <Col md={6}><span>License</span><p>{vendor.license_number}</p></Col>
                  <Col md={6}><span>Experience</span><p>{vendor.experience_years} Years</p></Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <div className="mt-3">
          <ChangePasswordCard endpoint="vendor/change-password" />
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal show={showEdit} onHide={() => setShowEdit(false)} size="lg">
        <Form onSubmit={handleEditSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Vendor Profile</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              {Object.keys(form).map((key) => (
                <Col md={6} key={key}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {key.replace(/_/g, " ").toUpperCase()}
                    </Form.Label>
                    <Form.Control
                      value={form[key]}
                      onChange={(e) =>
                        setForm({ ...form, [key]: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEdit(false)}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default VendorProfile;
